import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/subscription_table'
import SubscriptionService from '../../network/services/subscription'
import { serialize } from '../../network/request'
import SubscriptionTable from './SubscriptionTable'

const SubscriptionPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Subscription
    </Button>
  )

  return (
    <PageHeader title="All Subscriptions" extra={[primaryAction]}>
      <Card>
        <SubscriptionTableWrapper />
      </Card>
    </PageHeader>
  )
}

const SubscriptionTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(SubscriptionService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  console.log(response)

  if (!response) {
    return <Spin />
  }

  const { total } = SubscriptionService.toPaginate(response)

  return (
    <>
      <SubscriptionTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <SubscriptionTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default SubscriptionPage
